import React from 'react';
import {
  ServicesContainer,
  // ServicesH1,
  ServicesH2,
  Faqsdiv,
  Heading,
  // Faqstyle,
  // Faqimg,
  // ServicesWrapper,
  //Cardstyle,
  // ServicesCard,
  // ServicesIcon,
  // ServicesH2,
  // ServicesP,
} from './ServicesElements';
// import Faq1 from '../../images/faq1.png';
// import Faq2 from '../../images/faq2.png';

// import Card from "./filp";
import Faq from 'react-faq-component';

const data = {
  title: "",
  rows: [
    {
      title: "What are the Trippy Chicks?",
      content: `The Trippy Chicks are a collection of [number] unique 2D bird NFTs found flying on the Solana Blockchain.`,
    },
  ],
};
const data1 = {
  title: "",
  rows: [
    {
      title: "How do I get a Trippy Chick?",
      content: `There will be a pre-sale on [date] for members of our Discord and an open auction on [date] for the public.`,
    },
  ],
};
const data2 = {
  title: "",
  rows: [
    {
      title: "When are Trippy Chicks available?",
      content: `Trippy Chicks will be available in [month/year].`,
    },
  ],
};
const data3 = {
  title: "",
  rows: [
    {
      title: "How do I get Whitelisted for the pre-sale?",
      content: `To get on the Whitelist, join our Discord [link] and stay active as a member. `,
    },
  ],
};
const data4 = {
  title: "",
  rows: [
    {
      title: "How are the Trippy Chicks created?",
      content: `Trippy Chicks are born from the dreams of the Metaversal Mind and dipped in the psychedelic skies of color. Each will be generated uniquely to create [number] of completely different Trippy Chicks.`,
    },
  ],
};
const data5 = {
  title: "",
  rows: [
    {
      title:
        "What are the chances of getting a Downy, Feathered, or Flight Trippy Chick in the drop?",
      content: `Downy – 70%, Feathered – 27%, Flight – 3%`,
    },
  ],
};
const data6 = {
  title: "",
  rows: [
    {
      title: "Can I trade my Trippy Chick with others?",
      content: `Once you have your own Trippy Chick, you can trade, sell and buy others using [site, such as Open Sea]`,
    },
  ],
};
const data7 = {
  title: "",
  rows: [
    {
      title: "Where can I see my Trippy Chick?",
      content: `Initially, you will be able to find your NFT on [site, such as Open Sea], but we hope to add more apps later in development where you can show them off!`,
    },
  ],
};
const data8 = {
  title: "",
  rows: [
    {
      title: "How do I claim my Trippy Chick?",
      content: `Once you have your mint pass, your NFT will be generated and able to be claimed from [site, such as Open Sea].`,
    },
  ],
};

const styles = {
  bgColor: "rgba(255,255,255,0.25)",
  titleTextColor: "white",
  rowTitleColor: "white",
  fontfamily: "poppins",
  // rowContentColor: 'grey',
  // arrowColor: "red",
};

const config = {
  // animate: true,
  // arrowIcon: "V",
  // tabFocus: true
};
const Services = props => {
  return (
    <ServicesContainer id="faq">
      <Heading>frequently asked questions</Heading>
      <ServicesH2>FAQ'S</ServicesH2>
      <Faqsdiv>
        <Faq data={data} styles={styles} config={config} />
        <div style={{ marginTop: 20 }}></div>
        <Faq data={data1} styles={styles} config={config} />
        <div style={{ marginTop: 20 }}></div>
        <Faq data={data2} styles={styles} config={config} />
        <div style={{ marginTop: 20 }}></div>
        <Faq data={data3} styles={styles} config={config} />
        <div style={{ marginTop: 20 }}></div>
        <Faq data={data4} styles={styles} config={config} />
        <div style={{ marginTop: 20 }}></div>
        <Faq data={data5} styles={styles} config={config} />
        <div style={{ marginTop: 20 }}></div>
        <Faq data={data6} styles={styles} config={config} />
        <div style={{ marginTop: 20 }}></div>
        <Faq data={data7} styles={styles} config={config} />
        <div style={{ marginTop: 20 }}></div>
        <Faq data={data8} styles={styles} config={config} />
        {/* <div style={{ marginTop: 20 }}></div>
        <Faq data={data5} styles={styles} config={config} /> */}
        {/* <Faqimg src={Faq2} alt="loading" /> */}
        {/* <div style={{ flexDirection: 'column' }}>
          {' '}
          <Card
            front='What is the minting process'
            back='Connect your wallet to the Cheeky Lion Club website and mint
        1 to 10 random Lions for 0.07 eth each.'
          />
          <Card
            front='Secondary Royalties'
            back='0.5% lifetime for minters. 1.5% for Lion holders 4% Marketing and Team'
          />
          <Card
            front='Enter the Club Bar'
            back='Details on how to prove membership will be shared shortly after launch.'
          />
          <Card
            front='Members only Poker Night'
            back='You will have access to our members only online private poker rooms and tables,
        where you can compete against fellow Cheeky Lion members.'
          />
        </div> */}
        {/* <Faqimg src={Faq1} alt="loading" /> */}
      </Faqsdiv>
    </ServicesContainer>
  );
};

export default Services;
